/** Скрытый раздел /stat и серверные HTML-страницы статистики (не SPA). */
export function isStatPathname() {
	try {
		const raw = String(window.location.pathname || "");
		const p = raw.replace(/\/+$/, "") || "/";
		return p === "/stat" || p === "/stat/stat.html" || p === "/stat/widjet.html";
	} catch (e) {
		return false;
	}
}
